export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.form_label_containerContractNo') || '外运子单号',
    field: 'containerContractNo',
    width: 120,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_containerName') || '箱型',
    field: 'containerName',
    width: 120,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_editContainerNo') || '编辑柜号',
    field: 'editContainerNo',
    width: 100,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_containerNo') || '集装箱号',
    field: 'containerNo',
    width: 120,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_sealNo') || '箱封号',
    field: 'sealNo',
    width: 120,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title:
      that.$l('INDEX.form_label_containerBoxVolume') || '入柜总体积（立方米）',
    field: 'containerBoxVolume',
    width: 120,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title:
      that.$l('INDEX.form_label_containerBookingVolume') ||
      '入柜订舱总体积（立方米）',
    field: 'containerBookingVolume',
    width: 120,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_containerBoxQty') || '入柜总箱数',
    field: 'containerBoxQty',
    width: 120,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_totalNetWeight') || '总净重(kg)',
    field: 'containerNetWeight',
    width: 120,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_totalGrossWeight') || '总毛重（kg）',
    field: 'containerGrossWeight',
    width: 120,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_totalGoodsQty') || '入柜产品总数量',
    field: 'containerGoodsQty',
    width: 120,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_totalPriceAmount') || '工厂金额',
    field: 'containerAmount',
    width: 150,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
    slots: { default: 'containerAmount' },
  },
  {
    title: that.$l('INDEX.form_label_containerSalePrice') || '入柜销售总价',
    field: 'containerSalePrice',
    width: 150,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
    slots: { default: 'containerSalePrice' },
  },
]
